import { Attachment } from './attachment';

export class EnterpriseEmailSection {
	public id: number;
	public enterpriseId: number;
	public emailSectionId: number;
	public content: string;
	public attachmentId: string;
	public attachment: Attachment;

	constructor(entity?: Partial<EnterpriseEmailSection>) {
		Object.assign(this, entity);
		this.attachment = this.attachment ? new Attachment(this.attachment) : this.attachment;
	}
}
